<script setup lang="ts">
import { EffectFade, FreeMode, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import 'swiper/css'
import 'swiper/css/free-mode'

defineProps({
  data: {
    type: Array as PropType<SectionTeamRecord['records']>,
    default: () => []
  }
})

const modules = [EffectFade, FreeMode, A11y]
</script>

<template>
  <Swiper
    :modules="modules"
    :slides-per-view="'auto'"
    :freeMode="true"
    :space-between="32"
    :grab-cursor="true"
    class="w-full !px-4 !pb-10"
  >
    <SwiperSlide v-for="(item, index) in data" :key="index" class="!w-fit">
      <div div :key="idx" class="flex shrink-0 flex-col">
        <Image
          v-if="item.media"
          loading="lazy"
          class="mb-6 aspect-4/3 w-full overflow-hidden rounded-[2.125rem]"
          sizes="auto"
          :src="item.media?.responsiveImage ? item.media?.responsiveImage?.src : item.media?.url"
          :srcset="
            item.media?.responsiveImage ? item.media?.responsiveImage?.webpSrcSet : undefined
          "
          :width="
            item.media?.responsiveImage
              ? item.media?.responsiveImage?.width
              : (item.media?.width ?? 320)
          "
          :height="
            item.media?.responsiveImage
              ? item.media?.responsiveImage?.height
              : (item.media?.height ?? 240)
          "
          :alt="item.media?.alt ?? ''"
        />
        <div class="pl-4 font-bold lg:text-2xl">{{ item.name }}</div>
        <div class="pl-4 text-sm lg:text-lg">{{ item.role }}</div>
      </div>
    </SwiperSlide>
    <SwiperNav class="absolute bottom-0 left-auto right-4 z-20 w-fit lg:left-8 lg:right-auto" />
  </Swiper>
</template>
